import React from 'react';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router';
import NavigationConfig from '../../../../navigation/config';
import { allowedActions } from '../../configuration';
import * as AuthSelectors from '../../../../redux/reducers/gl_auth_reducer/selectors';
import { useDispatch } from 'react-redux';
import RegistrationDetailActions from '../../../../redux/reducers/registration_detail_reducer/actions';
import clsx from 'clsx';
import useStyles from './styles';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';

interface IProps {
  registration_id: string;
  status: string;
  state: string;
}

export default function ActionsBlock(props: IProps) {
  const history = useHistory();
  const ROLE = AuthSelectors.useSelectUserRole();
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClick = (type: 'view' | 'edit') => {
    history.push(
      NavigationConfig.registrationDetailPage(props.registration_id, type).path
    );
  };

  const updateRegistration = () => {
    let rId = Number.parseInt(props.registration_id);
    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.UPDATE_REGISTRATION_CONFIRM_MODAL,
        params: { rId },
      })
    );
  };

  const excludeRegistration = () => {
    let rId = Number.parseInt(props.registration_id);
    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.EXCLUDE_REGISTRATION_CONFIRM_MODAL,
        params: { rId },
      })
    );
  };

  const cancelRegistration = () => {
    let rId = Number.parseInt(props.registration_id);
    dispatch(
      RegistrationDetailActions.cancelRegistration({
        history,
        id: rId,
      })
    );
  };

  const updateButtonStyling = clsx({
    [classes.textColorGreen]: allowedActions.update.state_status.includes(
      `${props.status}${props.state}`
    ),
  });

  const excludeButtonStyling = clsx({
    [classes.textRedColor]: allowedActions.exclude.state_status.includes(
      `${props.status}${props.state}`
    ),
  });

  return (
    <div>
      {allowedActions.cancel.roles.includes(ROLE) && (
        <Button
          disabled={
            !allowedActions.cancel.state_status.includes(
              `${props.status}${props.state}`
            )
          }
          // className={updateButtonStyling}
          onClick={cancelRegistration}
        >
          Cancel
        </Button>
      )}
      {allowedActions.update.roles.includes(ROLE) && (
        <Button
          disabled={
            !allowedActions.update.state_status.includes(
              `${props.status}${props.state}`
            )
          }
          className={updateButtonStyling}
          onClick={updateRegistration}
        >
          Update
        </Button>
      )}
      {allowedActions.exclude.roles.includes(ROLE) && (
        <Button
          disabled={
            !allowedActions.exclude.state_status.includes(
              `${props.status}${props.state}`
            )
          }
          className={excludeButtonStyling}
          onClick={excludeRegistration}
        >
          Exclude
        </Button>
      )}
      {allowedActions.edit.roles.includes(ROLE) && (
        <Button
          disabled={
            !allowedActions.edit.state_status.includes(
              `${props.status}${props.state}`
            )
          }
          onClick={() => handleClick('edit')}
        >
          Edit
        </Button>
      )}
      <Button onClick={() => handleClick('view')}>View</Button>
    </div>
  );
}
